import { Link } from 'react-router-dom';
import LabsShell from './LabsShell';

/**
 * Catch-all outside /travo and /membersheep, prerendered to dist/404.html. Cloudflare Pages
 * serves it with a 404 status for unknown URLs at the root. noindex, no canonical.
 */
const LabsNotFoundPage = () => (
  <LabsShell>
    <title>Page not found | Travo Labs</title>
    <meta name="robots" content="noindex" />
    <main className="mx-auto flex max-w-[1120px] flex-col items-start gap-5 px-4 pt-24 md:px-6 md:pt-36">
      <p className="font-display text-[clamp(72px,14vw,160px)] leading-none font-extrabold tracking-[-0.05em] text-sys-faint">
        404
      </p>
      <h1 className="font-display text-4xl font-extrabold tracking-[-0.03em]">This page doesn't exist.</h1>
      <p className="text-sys-secondary">It may have moved. Travo now lives at /travo.</p>
      <Link to="/" className="rounded-xl bg-sys-label px-5 py-3 text-[15px] font-semibold text-white dark:text-black">
        Back to Travo Labs
      </Link>
    </main>
  </LabsShell>
);

export default LabsNotFoundPage;
